export interface User {
  email: string;
  userId: string;
  roles?: number[];
  userName?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  mobileNumber?: string;
  type?: 'weave' | 'internal' | 'practice';
}
export interface PortalUser {
  userID: string;
  username: string;
  firstName?: string;
  lastName?: string;
  mobileNumber?: string;
  type: 'weave' | 'internal' | 'practice';
}

/**
 * const storage keys or URL param keys for auth-related data
 */
export enum AuthStorage {
  user = 'user',
  weave_token = 'token',
  jti = 'jti',
  token_received_at = 'token_received_at',
  forward_url = 'forward_url',
  sign_in_fingerprint = 'sign_in_fingerprint',
  sign_in_method = 'sign_in_method',
  oauth_client_info = 'oauth_client_info',
  original_uri = 'original_uri',
  oidc_token_storage = 'oidc-token-storage',
  expire_length = 'token_expire_length',
  remembered_username = 'remembered_username',
  cached_challenge = 'cached_challenge',
  sso_tenant = 'sso_tenant',
  login_features = 'login_features_json',
  login_features_checked = 'login_features_checked',
  time_to_auth_redirect = 'time_to_auth_redirect',
  login_challenge = 'login_challenge',
  consent_challenge = 'consent_challenge',
  logout_challenge = 'logout_challenge',
  oidc_code_verifier = 'code_verifier',
  oidc_state_nonce = 'state_nonce',
}

export type SsoTenant = {
  tenant: string;
  clientId: string;
  redirectUri: string;
};

export type SignInMethod = 'okta' | 'legacy' | 'oidc';

export type AuthConfig = {
  oktaIssuer?: string;
  oktaClientID?: string;
  oktaRedirectUri?: string;
  oidcIssuer?: string;
  oidcClientID?: string;
  oidcRedirectUri?: string;
  backendAPI?: string;
  appSource?: string;
};
